/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Cotermination } from './Cotermination';
import {
    CoterminationFromJSON,
    CoterminationFromJSONTyped,
    CoterminationToJSON,
} from './Cotermination';
import type { LicenseRequirementEnum } from './LicenseRequirementEnum';
import {
    LicenseRequirementEnumFromJSON,
    LicenseRequirementEnumFromJSONTyped,
    LicenseRequirementEnumToJSON,
} from './LicenseRequirementEnum';
import type { PublicProductSku } from './PublicProductSku';
import {
    PublicProductSkuFromJSON,
    PublicProductSkuFromJSONTyped,
    PublicProductSkuToJSON,
} from './PublicProductSku';
import type { Subscription } from './Subscription';
import {
    SubscriptionFromJSON,
    SubscriptionFromJSONTyped,
    SubscriptionToJSON,
} from './Subscription';

/**
 * Check a license_number and what entitlement it provides, prior to 'activating' it into a new/existing tenant
 * @export
 * @interface OrderValidation
 */
export interface OrderValidation {
    /**
     * 
     * @type {string}
     * @memberof OrderValidation
     */
    licenseNumber: string;
    /**
     * 
     * @type {LicenseRequirementEnum}
     * @memberof OrderValidation
     */
    licenseRequirement?: LicenseRequirementEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderValidation
     */
    tenantId?: string | null;
    /**
     * 
     * @type {PublicProductSku}
     * @memberof OrderValidation
     */
    readonly product: PublicProductSku;
    /**
     * 
     * @type {Subscription}
     * @memberof OrderValidation
     */
    readonly subscription: Subscription | null;
    /**
     * 
     * @type {number}
     * @memberof OrderValidation
     */
    readonly deviceCount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderValidation
     */
    readonly orderNumber: string;
    /**
     * 
     * @type {string}
     * @memberof OrderValidation
     */
    readonly signedData: string;
    /**
     * 
     * @type {Cotermination}
     * @memberof OrderValidation
     */
    readonly cotermination: Cotermination | null;
}

/**
 * Check if a given object implements the OrderValidation interface.
 */
export function instanceOfOrderValidation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "licenseNumber" in value;
    isInstance = isInstance && "product" in value;
    isInstance = isInstance && "subscription" in value;
    isInstance = isInstance && "deviceCount" in value;
    isInstance = isInstance && "orderNumber" in value;
    isInstance = isInstance && "signedData" in value;
    isInstance = isInstance && "cotermination" in value;

    return isInstance;
}

export function OrderValidationFromJSON(json: any): OrderValidation {
    return OrderValidationFromJSONTyped(json, false);
}

export function OrderValidationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderValidation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'licenseNumber': json['license_number'],
        'licenseRequirement': !exists(json, 'license_requirement') ? undefined : LicenseRequirementEnumFromJSON(json['license_requirement']),
        'tenantId': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'product': PublicProductSkuFromJSON(json['product']),
        'subscription': SubscriptionFromJSON(json['subscription']),
        'deviceCount': json['device_count'],
        'orderNumber': json['order_number'],
        'signedData': json['signed_data'],
        'cotermination': CoterminationFromJSON(json['cotermination']),
    };
}

export function OrderValidationToJSON(value?: OrderValidation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'license_number': value.licenseNumber,
        'license_requirement': LicenseRequirementEnumToJSON(value.licenseRequirement),
        'tenant_id': value.tenantId,
    };
}

